import React, { useMemo } from 'react';
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { t } from 'i18next';
import HighlighterWrapper from "@components/highlighterWrapper/HighlighterWrapper";
import EncryptUtils from "src/utils/EncryptUtils";
import { SEARCH_CONTEXT } from "src/routes/BaseRoute";
import { Buffer } from 'buffer';

interface HTMLViewerProps {
  base64Html: string;
}

const HTMLViewer: React.FC<HTMLViewerProps> = ({ base64Html }) => {
  const location = useLocation();
  const search_context = EncryptUtils.getDecryptedData(location?.search, SEARCH_CONTEXT);

  // Convert base64 to a Blob URL so the iframe can't "leak" styles to the main app
  const blobUrl = useMemo(() => {
    if (!base64Html) return null;
    try {
      const decoded = Buffer.from(base64Html, 'base64').toString('utf-8');
      // We inject a small CSS fix inside the blob to ensure tables wrap
      const styledHtml = `
        <html>
          <head>
             <style>
        
             </style>
          </head>
          ${decoded}
        </html>
      `;
      const blob = new Blob([styledHtml], { type: 'text/html' });
      return URL.createObjectURL(blob);
    } catch (e) {
      console.error("Blob conversion error", e);
      return null;
    }
  }, [base64Html]);

  if (!base64Html || !blobUrl) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6">{t('PRIVATE.DOCUMENT.NO_PREVIEW_AVAILABLE', { ns: 'private' })}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'hidden', // Forces the container to stay rigid
      backgroundColor: '#fff' 
    }}>
      <HighlighterWrapper keywords={[search_context]}>
        <iframe
          src={blobUrl}
          title="HTML Document Viewer"
          sandbox="allow-same-origin"
          style={{
            width: '100%',
            height: '70vh', // Matches your MainContainer height
            border: 'none',
            display: 'block',
            marginBottom:10,
            padding:20
          }}
        />
      </HighlighterWrapper>
    </Box>
  );
};

export default HTMLViewer;